import React from 'react';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { isEmpty } from 'lodash';

import { Divider, Typography, List, ListItem } from '@mui/material';

const NoteList = ({
  notes,
  anonymisedSession,
  listClassName,
  listItemClassName,
  emptyListClassName,
}) => {
  const { t } = useTranslation();

  return (
    <List className={listClassName}>
      {isEmpty(notes) && !anonymisedSession ? (
        <ListItem alignItems="center" className={emptyListClassName}>
          {t('no_note')}
        </ListItem>
      ) : !isEmpty(notes) && anonymisedSession ? (
        <ListItem alignItems="center" className={emptyListClassName}>
          {t('anonymised_notes')}
        </ListItem>
      ) : (
        notes.map((note, i) => (
          <>
            <ListItem className={listItemClassName} key={note.id}>
              <Typography align="left" style={{ textAlign: 'left' }}>
                {note.note}
              </Typography>
              <Typography
                align="right"
                style={{ fontWeight: 'bold', fontSize: '12px' }}>
                {note.user_name +
                  ' on ' +
                  moment(note.created_at).format('DD-MM-YYYY, h:mm:ss A')}
              </Typography>
            </ListItem>
            {i < notes.length - 1 && <Divider style={{ margin: '10px 0' }} />}
          </>
        ))
      )}
    </List>
  );
};

export default NoteList;
